import { render } from "./AppointmentConfirmation.vue?vue&type=template&id=80483fc8&scoped=true"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js"

import "./AppointmentConfirmation.vue?vue&type=style&index=0&id=80483fc8&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80483fc8"]])

export default __exports__